import styled, { css } from "styled-components";
import { SelectCssProps } from "./Select.types";
import { ArrowDownOutlined } from "@ant-design/icons";
import { ThemePalette } from "../../../theme";
export const PropelSelectitem = styled.li<SelectCssProps>`
  display: flex;
  flex-wrap: nowrap;
  cursor: pointer;
  div,
  span {
    padding: 0.5rem 1rem;
    display: block;
    user-select: none;
    text-align: left;
  }

  div {
    img {
      width: 1rem;
    }
  }

  :hover {
    background-color: ${(props: SelectCssProps) =>
      `${props.theme!.colorGrayDark}${40}`};
  }

  &:after {
    content: " ";
    display: block;
    margin: 0rem 0.5rem;
    border-bottom: 1px solid
      ${(props: SelectCssProps) => `${props.theme!.colorGray}${40}`};
  }

  &:last-child:after {
    border-bottom: none;
    margin: none;
  }
`;

const SelectShadowCss = (props: SelectCssProps) => css`
  box-shadow: 0px 2px 4px -1px ${props.theme!.colorGrayDark}${75},
    0px 4px 5px 0px ${props.theme!.colorGrayDark}${80},
    0px 1px 10px 0px ${props.theme!.colorGrayDark}${85};
`;
export const PropelOptionsList = styled.ul<SelectCssProps>`
  margin-left: 0.1rem;
  z-index: 999;
  position: absolute;
  padding: 0;
  margin: 0;
  top: 4.5rem;
  width: 100%;
  background: ${(props: SelectCssProps) => props.theme!.colorWhite};
  list-style: none;
  max-height: 12rem;
  overflow: auto;
  overflow-x: hidden;
  ${(props) => SelectShadowCss(props)}

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0.4rem;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 0.4rem;
    background-color: ${(props: SelectCssProps) =>
      `${props.theme!.colorGrayDark}${40}`};
  }
`;

export const DownArrowIcon = styled(ArrowDownOutlined)<SelectCssProps>`
  transform: ${(props: SelectCssProps) => props.reverse && "rotateX(-180deg)"};
  width: 1.2rem;
  height: 1.2rem;
  transition: all 0.3s ease;
`;

export const PropelSelect = styled.div`
  position: relative;
`;

PropelSelect.defaultProps = {
  theme: ThemePalette,
};
PropelOptionsList.defaultProps = {
  theme: ThemePalette,
};
PropelSelectitem.defaultProps = {
  theme: ThemePalette,
};
